import { SignInType, useAncestryLogin } from 'hooks/useAncestryLogin';
import { useAncestryLogout } from 'hooks/useAncestryLogout';
import {
  ELinkHrefOption,
  ILibUIComponentsComponents,
  TLibUIComponentsUseLogin,
  TLibUIComponentsUseLogout,
  TLinkComponent,
} from 'petdna-lib-uicomponents/types';
import { Link } from 'react-router-dom';

export const libUIComponentsComponents: ILibUIComponentsComponents = {
  Link: Link as React.ComponentType<TLinkComponent>,
  LinkProps: {
    href: ELinkHrefOption.to,
  },
};

export const useLibUIComponentsLogin: TLibUIComponentsUseLogin = (
  returnUrl?: string,
) => useAncestryLogin(SignInType.Signup, returnUrl);

export const useLibUIComponentsLogout: TLibUIComponentsUseLogout = () => useAncestryLogout();
